import React, { Component } from "react";
import { Row, Col, Image, Accordion, Card, Button } from "react-bootstrap";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import Alerts from "./Alerts";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import RejectIcon from "../../../assets/images/RejectIcon.svg";
import ApprovedChecked from "../../../assets/images/CheckedApproved.png";
import Group from "../../../assets/images/group.png";

import SealCheckDark from "../../../assets/images/SealCheckDark.svg";
import HourGlassDark from "../../../assets/images/HourGlassDark.svg";
import HourGlass from "../../../assets/images/HourGlass.svg";
import approved from "../../../assets/images/approved.svg";
import delivaApiService from "../../../common/services/apiService";
import validateInput from "../../../common/validations/validateProofs";
import {
  getLocalStorage,
  getStatusClassName,
  getVerificationTagClass,
  showErrorToast,
} from "../../../common/helpers/Utils";
import CONSTANTS from "../../../common/helpers/Constants";
import { error } from "jquery";
import CaretDownArrow from "../../../assets/images/CaretDoubleDown.svg";
import CopyButton from "../../common/CopyButton";
import DeliveryBankDetail from "./DeliveryBankDetail";
import CustomKycModal from "../../common/CustomKycModal";
import group1 from "../../../assets/images/placeholder.svg";
import PlaceHolderContent from "../../../common/helpers/PlaceHolderContent";

class DeliveryAgentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      profile_detail: {},
      showRejectModal: false,
      passportVerification: false,
      nationalIdVerification: false,
      bankVerification: false,
      idproofVerification: false,
      lisenceIdProofVerification: false,
      lisenceVerificationDA: false,
      errors: {},
      rejectionReason: "Other",
      successModal: false,
      idProof: CONSTANTS.DAIDPROOF.PASSPORTLICENCE,
      selectedOption: "resubmit",
      userKycDetailsResponse: {},
      copied: false,
      kycApprovedByAdmin: false,
      kycRemark: "",
      pageType: "KycPage",
      showKycApproveModal: false,
      kycRejectRemark: "",
      description: "",
      documentationType: "MANUAL_DOCUMENTATION",
    };
    this.handleToggleIcon = this.handleToggleIcon.bind(this);
  }

  handleToggleIcon() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen, // Toggle the isOpen state
    }));
  }

  handleRadioChange = (val) => {
    this.setState({ selectedOption: val });
  };

  handleReject = (userId) => {
    this.setState({
      showRejectModal: !this.state.showRejectModal,
      userId,
    });
  };

  openKycApproveModel = () => {
    this.setState({
      showKycApproveModal: true,
    });
  };

  componentDidMount() {
    if (this?.props && this?.props?.location?.state?.item) {
      this.getDeliveryAgentProfile(this?.props?.location?.state?.item?.userId);
    }
  }

  checkDisabled = () => {
    const { profile_detail } = this.state;

    const { userKycDetailsResponse } = profile_detail || {};
    const { verificationDojahStatus, kycApprovedByAdmin } =
      userKycDetailsResponse || {};

    if (verificationDojahStatus === "Completed") {
      return true;
    } else if (kycApprovedByAdmin) {
      return true;
    } else {
      return false;
    }
  };

  getDeliveryAgentProfile = (id) => {
    this.setState({
      showLoader: true,
    });
    delivaApiService("deliveryAgentprofile", {
      daId: id,
      logInUserId: getLocalStorage("id"),
    })
      .then((response) => {
        this.setState({ showLoader: false });
        if (response.data.status == 200) {
          this.setState({ profile_detail: response.data.resourceData });
          if (
            response.data.resourceData.identificationDetails
              .drivingLicenceNumber
          ) {
            this.setState({ idProof: CONSTANTS.DAIDPROOF.DRIVINGLICENCE });
          }
          if (
            response.data.resourceData.identificationDetails.nationalIdNumber
          ) {
            this.setState({ idProof: CONSTANTS.DAIDPROOF.NATIONALLICENCE });
          }
        }
      })
      .catch((error) => {
        this.setState({
          showLoader: false,
        });
      });
  };

  approveDA = (userId, name) => {
    const validation = validateInput(this.state, "kycRemark");
    if (validation.isValid) {
      this.setState({
        showLoader: true,
        daName: name,
        userId: userId,
        errors: {},
      });
      const approveDaPayload = {
        userId: userId,
        kycApprovedByAdmin:
          this.state.documentationType === "MANUAL_DOCUMENTATION"
            ? true
            : this.state.kycApprovedByAdmin,
        verificationDetailsByAdmin: this.state.kycRemark,
      };
      delivaApiService("approveDA", approveDaPayload)
        .then((response) => {
          this.setState({
            showLoader: false,
            successModal: true,
            showKycApproveModal: false,
          });
          if (response.data.status == 200) {
            this.getDeliveryAgentProfile(userId);
          }
        })
        .catch((error) => {
          this.setState({
            showLoader: false,
          });
        });
    } else {
      this.setState({
        errors: validation.errors,
      });
    }
  };

  approvalSuccessModal = () => {
    this.props.history.push({
      pathname: "/verification/3",
      state: { profileDetail: this.state.profile_detail },
    });
  };

  switchPageView = () => {
    this.setState((prevState) => ({
      pageType: prevState.pageType === "KycPage" ? "BankPage" : "KycPage",
    }));
  };

  nextPageModal = () => {
    this.props.history.push({
      pathname: "/verification/3",
    });
  };

  updateErrors = (fieldName) => {
    const { errors } = validateInput(this.state, fieldName);

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        [`${fieldName}Error`]: errors[`${fieldName}Error`] || "",
      },
    }));
  };

  // onChange = (event) => {
  //   const target = event.target;
  //   const value = target.type === "checkbox" ? target.checked : target.value;
  //   const name = target.name;
  //   this.setState({ [name]: value }, () => {
  //     this.updateErrors(name);
  //   });
  // };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({ [name]: value }, () => {
      this.updateErrors(name);
    });
  };

  handleRemarksChange = (e) => {
    const { value } = e.target;

    this.setState({ kycRemark: value }, () => {
      this.updateErrors("kycRemark");
    });
  };

  submitReject = () => {
    const validation = validateInput(this.state, "kycRejectRemark");

    if (validation.isValid) {
      {
        let data = {
          reasonForRejection: this.state.rejectionReason,
          rejectionDetail: this.state.kycRejectRemark,
          userId: this.state.userId,
          docsResubmissionBlocked:
            this.state.selectedOption === "blocked" ? true : false,
        };
        delivaApiService("rejectDA", data)
          .then((response) => {
            this.setState({ showLoader: false });
            if (response.data.status == 200) {
              this.setState({
                showRejectModal: !this.state.showRejectModal,
              });
              this.props.history.push("/verification/3");
              this.getDeliveryAgentProfile(data.userId);
            }
          })
          .catch((error) => {
            this.setState({
              showLoader: false,
            });
          });
      }
    } else {
      this.setState({
        errors: validation.errors,
      });
    }
  };
  handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(this.textToCopy);
      this.setState({ copied: true });

      setTimeout(() => {
        this.setState({ copied: false });
      }, 2000);
    } catch (error) {
      console.error("Copy failed", error);
    }
  };

  handleCheckboxChange = () => {
    this.setState((prevState) => ({
      kycApprovedByAdmin: !prevState?.kycApprovedByAdmin,
    }));
  };

  getKycAlertVariant = () => {
    const status =
      this.state.profile_detail?.userKycDetailsResponse
        ?.verificationDojahStatus !== null
        ? this.state.profile_detail.userKycDetailsResponse
            .verificationDojahStatus
        : this.state.profile_detail?.userKycDetailsResponse
            ?.verificationAdminStatus;

    if (this.state.profile_detail?.userKycDetailsResponse.kycApprovedByAdmin) {
      return "success";
    }
    console.log(status, "STAYU");
    switch (status) {
      case "Completed":
        return "success";
      case "Failed":
        return "danger";
      case "Pending":
        return "warning";
      case "Ongoing":
        return "warning";

      case "Rejected":
        return "danger";
      default:
        return "default";
    }
  };

  getKycApprovalStatusClass = (isApproved) => {
    if (isApproved === true) {
      return "textGreen";
    } else if (isApproved === false) {
      return "textRed";
    } else {
      return "";
    }
  };

  render() {
    const { profile_detail, errors, isOpen } = this.state;

    const shouldHideKycSection =
      this?.props?.location?.state?.item.kycStatus === "Not Submitted" &&
      this?.props?.location?.state?.item.autoResubmitted == false;

    return (
      <div className="page__wrapper h-100">
        <Header {...this.props} />

        <div className="mainContainer CustomerTable">
          <Row noGutters className="h-100">
            <Sidebar {...this.props} />

            <Col md={9} lg={10} className="boxTyp3">
              <div className="container-fluid">
                <div className="content-wrapper">
                  <Row noGutters className="mb-3">
                    <Col md={6} lg={8} className="">
                      <h3 className="font-weight-normal fs28 mb-2 line-ht tertiary-color">
                        KYC Verification
                      </h3>
                      <h5 className="font-weight-normal fs18 mb-0 color-head">
                        <span
                          onClick={() =>
                            this.props.history.push("/verification/3")
                          }
                          className="pointer"
                        >
                          Delivery partners
                        </span>
                        <span className="icon-next mx-2 Fs12"></span> KYC
                        verification{" "}
                      </h5>
                    </Col>
                  </Row>
                  <ul
                    className={`wizards ${
                      this.state.pageType !== "KycPage" ? "success" : ""
                    }`}
                  >
                    <li className="wizard-step">
                      <div className="wizard-icon">
                        <img src={SealCheckDark} alt="" />
                      </div>
                      <span className="wizard-label">KYC Verification</span>
                    </li>
                    <li className="wizard-step">
                      <div className="wizard-icon">
                        <img
                          src={
                            this.state.pageType == "KycPage"
                              ? HourGlass
                              : HourGlassDark
                          }
                          alt=""
                        />
                      </div>
                      <span className="wizard-label">Bank Verification</span>
                    </li>
                  </ul>
                  {this.state.pageType === "KycPage" ? (
                    <>
                      <div className="details-wrap mb-4">
                        <Row noGutters>
                          <Col md={12} lg={12} className="">
                            <h5 className="px-4">Personal Details</h5>
                            <hr />
                          </Col>
                        </Row>
                        <Row className="px-4">
                          <Col md={6} lg={2} className="">
                            <div className="pr-wrap">
                              <h5 className="font-weight-normal color-grey fs18">
                                Name
                              </h5>
                              <h5 className="fs18 font-weight-normal">
                                {profile_detail.name || ""}
                              </h5>
                            </div>
                          </Col>
                          <Col md={6} lg={2} className="">
                            <div className="">
                              <h5 className="font-weight-normal color-grey fs18">
                                Partner ID
                              </h5>
                              <h5 className="fs18 font-weight-normal">
                                #{profile_detail.userId}
                              </h5>
                            </div>
                          </Col>
                          <Col md={6} lg={2} className="">
                            <div className="">
                              <h5 className="font-weight-normal color-grey fs18">
                                Business Name
                              </h5>
                              <h5 className="fs18 font-weight-normal">
                                {profile_detail.businessName || "-"}
                              </h5>
                            </div>
                          </Col>
                          <Col md={6} lg={2} className="">
                            <div className="">
                              <h5 className="font-weight-normal color-grey fs18">
                                Date of Registration
                              </h5>
                              <h5 className="fs18 font-weight-normal">
                                {moment(
                                  this.props?.location?.state?.item
                                    ?.createdDate,
                                )
                                  .utc()
                                  .format("DD MMM YYYY")}
                              </h5>
                            </div>
                          </Col>
                          <Col md={6} lg={2} className="">
                            <div className="">
                              <h5 className="font-weight-normal color-grey fs18">
                                Contact
                              </h5>
                              {profile_detail.countryCode &&
                              profile_detail.mobile ? (
                                <h5 className="fs18 font-weight-normal">
                                  +{profile_detail.countryCode}-
                                  {profile_detail.mobile}
                                </h5>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                        </Row>
                        <hr />
                        <Row className="px-4">
                          <Col md={3} lg={3}>
                            <h5 className="font-weight-normal color-grey fs18">
                              Email
                            </h5>
                            <h4 className="fs18 font-weight-normal">
                              {profile_detail.email}
                            </h4>
                          </Col>
                          <Col md={3} lg={3}>
                            <h5 className="font-weight-normal color-grey fs18">
                              Address
                            </h5>
                            <h5 className="fs18 font-weight-normal">
                              {profile_detail.address || ""}
                            </h5>
                          </Col>

                          <Col md={3} lg={3}>
                            <h5 className="font-weight-normal color-grey fs18">
                              Last Login
                            </h5>
                            <h5 className="fs18 font-weight-normal">
                              {profile_detail.lastLogin
                                ? moment(profile_detail.lastLogin).format(
                                    "DD MMM YYYY | h:mm A",
                                  )
                                : "-"}
                            </h5>
                          </Col>
                          <Col md={6} lg={3}>
                            <h5 className="font-weight-normal color-grey fs18">
                              Source
                            </h5>
                            <h5 className="fs18 font-weight-normal">
                              {profile_detail.source || ""}
                            </h5>
                          </Col>
                        </Row>
                      </div>
                      {profile_detail?.userKycDetailsResponse
                        ?.verificationMessage && (
                        <Alerts
                          variant={this.getKycAlertVariant()}
                          content={
                            this.state.profile_detail?.userKycDetailsResponse
                              ?.verificationMessage || ""
                          }
                          className="mb-3"
                        />
                      )}

                      {shouldHideKycSection ? (
                        <PlaceHolderContent
                          img={group1}
                          heading="KYC Documents"
                          content="The delivery partner has not submitted the Kyc verification data"
                        />
                      ) : (
                        <div className="details-wrap mb-4">
                          <Row>
                            <Col md={6} lg={6}>
                              <h5 className="px-4 mb-2">KYC documents</h5>
                              <hr className="mb-3" />
                            </Col>
                            <Col md={6} lg={6}>
                              <div
                                className={`px-4 mt-md-2 d-flex justify-content-end ${getVerificationTagClass(
                                  profile_detail?.userKycDetailsResponse
                                    ?.verificationTag,
                                )}`}
                              >
                                {
                                  profile_detail?.userKycDetailsResponse
                                    ?.verificationTag
                                }
                              </div>
                              <hr className="mt-3" />
                            </Col>
                          </Row>

                          <div className="kyc-document px-4">
                            <Row>
                              <Col lg={4}>
                                <Card className="card-link mb-4">
                                  <Card.Body className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                      <h5 className="fs14">
                                        ID url of front image
                                      </h5>
                                      {/* {profile_detail.userKycDetailsResponse
                                        ?.idImageUrl && ( */}
                                      <CopyButton
                                        textToCopy={
                                          profile_detail.userKycDetailsResponse
                                            ?.idImageUrl
                                        }
                                      />
                                      {/* )} */}
                                    </div>
                                    <a
                                      href={
                                        profile_detail.userKycDetailsResponse
                                          ?.idImageUrl
                                      }
                                    >
                                      {
                                        profile_detail.userKycDetailsResponse
                                          ?.idImageUrl
                                      }
                                    </a>
                                  </Card.Body>
                                </Card>
                                <Card className="card-id mb-4">
                                  <Card.Body>
                                    <Image
                                      className="img-fluid"
                                      src={
                                        profile_detail.userKycDetailsResponse
                                          ?.idImageUrl
                                      }
                                    />
                                  </Card.Body>
                                </Card>
                              </Col>
                              <Col lg={4}>
                                <Card className="card-link mb-4">
                                  <Card.Body className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                      <h5 className="fs14">
                                        ID url of back image
                                      </h5>
                                      <CopyButton
                                        textToCopy={
                                          profile_detail?.userKycDetailsResponse
                                            ?.backImageUrl
                                        }
                                      />
                                    </div>
                                    <a
                                      href={
                                        profile_detail?.userKycDetailsResponse
                                          ?.backImageUrl
                                      }
                                    >
                                      {
                                        profile_detail?.userKycDetailsResponse
                                          ?.backImageUrl
                                      }
                                    </a>
                                  </Card.Body>
                                </Card>
                                <Card className="card-id mb-4">
                                  <Card.Body>
                                    <Image
                                      className="img-fluid"
                                      src={
                                        profile_detail?.userKycDetailsResponse
                                          ?.backImageUrl
                                      }
                                    />
                                  </Card.Body>
                                </Card>
                              </Col>
                            </Row>
                          </div>
                          <div className="kyc-data px-4">
                            <Row>
                              <Col md={6} lg={3} className="mb-4">
                                <div className="pr-wrap">
                                  <label className="font-weight-normal color-grey fs18">
                                    Expiry Date
                                  </label>
                                  <h5 className="fs18 font-weight-normal">
                                    {profile_detail?.userKycDetailsResponse
                                      ?.expiryDate
                                      ? moment(
                                          profile_detail?.userKycDetailsResponse
                                            .expiryDate,
                                        )
                                          .utc()
                                          .format("DD MMM YYYY")
                                      : "--"}
                                  </h5>
                                </div>
                              </Col>
                              <Col md={6} lg={3} className="mb-4">
                                <div className="pr-wrap">
                                  <label className="font-weight-normal color-grey fs18">
                                    Country
                                  </label>
                                  <h5 className="fs18 font-weight-normal">
                                    {profile_detail?.userKycDetailsResponse
                                      ?.country || "--"}
                                  </h5>
                                </div>
                              </Col>
                              <Col md={6} lg={3} className="mb-4">
                                <div className="pr-wrap">
                                  <label className="font-weight-normal color-grey fs18">
                                    Date of Birth
                                  </label>
                                  <h5 className="fs18 font-weight-normal">
                                    {profile_detail?.userKycDetailsResponse
                                      ?.dateOfBirth
                                      ? moment(
                                          profile_detail.userKycDetailsResponse
                                            .dateOfBirth,
                                        )
                                          .utc()
                                          .format("DD MMM YYYY")
                                      : "--"}
                                  </h5>
                                </div>
                              </Col>
                              <Col md={6} lg={3} className="mb-4">
                                <div className="pr-wrap">
                                  <label className="font-weight-normal color-grey fs18">
                                    Email
                                  </label>
                                  <h5 className="fs18 font-weight-normal">
                                    {profile_detail?.userKycDetailsResponse
                                      ?.email || "--"}
                                  </h5>
                                </div>
                              </Col>
                              {profile_detail?.documentationType ===
                                "DOJAH_DOCUMENTATION" && (
                                <Col md={6} lg={3} className="mb-4 mb-md-0">
                                  <div className="pr-wrap">
                                    <label className="font-weight-normal color-grey fs18">
                                      {`Verified by ${
                                        profile_detail?.userKycDetailsResponse?.kycCategoryProvider?.includes(
                                          "SUMSUB_KYC",
                                        )
                                          ? "Sumsub"
                                          : "Dojha"
                                      }`}
                                    </label>
                                    <h5
                                      className={`fs18 font-weight-normal ${getStatusClassName(
                                        profile_detail?.userKycDetailsResponse
                                          ?.verificationDojahStatus,
                                      )}`}
                                    >
                                      {profile_detail?.userKycDetailsResponse
                                        ?.verificationDojahStatus
                                        ? profile_detail.userKycDetailsResponse
                                            .verificationDojahStatus
                                        : "--"}
                                    </h5>
                                  </div>
                                </Col>
                              )}

                              {profile_detail?.documentationType ===
                                "DOJAH_DOCUMENTATION" &&
                                profile_detail?.userKycDetailsResponse
                                  ?.expiryNote && (
                                  <Col md={6} lg={3} className="mb-0">
                                    <div className="pr-wrap">
                                      <label className="font-weight-normal text-muted fs18">
                                        Note
                                      </label>
                                      <h5 className="fs18 font-weight-normal">
                                        <span>
                                          {
                                            profile_detail
                                              ?.userKycDetailsResponse
                                              ?.expiryNote
                                          }
                                        </span>
                                      </h5>
                                    </div>
                                  </Col>
                                )}

                              <Col md={6} lg={3} className="mb-0">
                                <div className="pr-wrap">
                                  <label className="font-weight-normal color-grey fs18">
                                    Identification Number
                                  </label>
                                  <h5 className="fs18 font-weight-normal">
                                    {profile_detail?.userKycDetailsResponse
                                      ?.idNumber || "--"}
                                  </h5>
                                </div>
                              </Col>

                              {this.state.profile_detail?.userKycDetailsResponse
                                ?.kycApprovedByAdmin ||
                                (this.state.profile_detail.rejected == true && (
                                  <Col md={6} lg={3} className="mb-0">
                                    <div className="pr-wrap">
                                      <label className="font-weight-normal color-grey fs18">
                                        Verified By Admin
                                      </label>
                                      <h5
                                        className={`fs18 font-weight-normal ${this.getKycApprovalStatusClass(
                                          this.state?.profile_detail
                                            ?.userKycDetailsResponse
                                            ?.kycApprovedByAdmin,
                                        )}`}
                                      >
                                        {
                                          this.state.profile_detail
                                            ?.userKycDetailsResponse
                                            ?.verificationAdminStatus
                                        }
                                      </h5>
                                    </div>
                                  </Col>
                                ))}
                            </Row>
                            <div className="mt-4">
                              {profile_detail?.documentationType ===
                                "DOJAH_DOCUMENTATION" &&
                                profile_detail?.userKycDetailsResponse
                                  ?.additionalNotes && (
                                  <Accordion
                                    defaultActiveKey="0"
                                    className="accType2 mb-4 "
                                    onSelect={this.handleToggleIcon}
                                  >
                                    <Card className="bg-lightgray border-0">
                                      <Card.Header className="px-3 py-2 border-0 bg-transparent">
                                        <Accordion.Toggle
                                          as={Button}
                                          variant="link"
                                          eventKey="0"
                                          className="w-100 text-left color-black p-0 font-weight-bold text-decoration-none"
                                        >
                                          Additional information{" "}
                                          <Image
                                            src={CaretDownArrow}
                                            style={{ maxHeight: "16px" }}
                                            className={`img-fluid user-block-img float-right rotate-icon ${
                                              isOpen ? "rotated" : ""
                                            }`}
                                          />
                                        </Accordion.Toggle>
                                      </Card.Header>

                                      <Accordion.Collapse eventKey="0">
                                        <Card.Body className="px-3 py-2">
                                          {profile_detail?.documentationType ===
                                            "DOJAH_DOCUMENTATION" &&
                                            profile_detail
                                              ?.userKycDetailsResponse
                                              ?.additionalNotes}
                                        </Card.Body>
                                      </Accordion.Collapse>
                                    </Card>
                                  </Accordion>
                                )}

                              {profile_detail?.documentationType ===
                              "MANUAL_DOCUMENTATION" ? (
                                <div className="d-flex mt-4 gap-3 mb-1">
                                  <button
                                    className="df-button danger"
                                    onClick={this.handleReject.bind(
                                      this,
                                      profile_detail?.userId,
                                    )}
                                  >
                                    Reject
                                  </button>
                                  <button
                                    className="df-button success"
                                    onClick={this.openKycApproveModel.bind(
                                      this,
                                    )}
                                    disabled={
                                      this.state.profile_detail
                                        ?.userKycDetailsResponse
                                        ?.kycApprovedByAdmin
                                    }
                                  >
                                    Approve
                                  </button>
                                </div>
                              ) : (
                                profile_detail?.userKycDetailsResponse &&
                                profile_detail?.userKycDetailsResponse
                                  ?.verificationDojahStatus !== "Completed" && (
                                  <>
                                    <div className="checkboxContainer mb-4">
                                      <input
                                        type="checkbox"
                                        id="kycApprovedByAdmin"
                                        checked={this.state?.kycApprovedByAdmin}
                                        onChange={this.handleCheckboxChange}
                                      />
                                      <label
                                        htmlFor="kycApprovedByAdmin"
                                        className="input-label"
                                      >
                                        KYC Verification by admin
                                      </label>
                                    </div>

                                    {this.state?.kycApprovedByAdmin && (
                                      <>
                                        <div className="d-flex mt-4 gap-3 mb-1">
                                          <button
                                            className="df-button danger"
                                            onClick={this.handleReject.bind(
                                              this,
                                              profile_detail.userId,
                                            )}
                                          >
                                            Reject
                                          </button>
                                          <button
                                            className="df-button success"
                                            onClick={this.openKycApproveModel.bind(
                                              this,
                                            )}
                                            disabled={
                                              this.state.profile_detail
                                                ?.userKycDetailsResponse
                                                ?.kycApprovedByAdmin
                                            }
                                          >
                                            Approve
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </>
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <DeliveryBankDetail
                      profileDetail={profile_detail}
                      getDeliveryAgentProfile={this.getDeliveryAgentProfile}
                    />
                  )}
                  {this?.props?.location?.state?.item.bankingStatus ==
                  "Skipped" ? (
                    <PlaceHolderContent
                      img={group1}
                      heading="Bank Documents"
                      content="The delivery partner has not submitted the Bank
                           verification data"
                    />
                  ) : null}

                  <div></div>
                  {this.state.profile_detail.bankingDetails && (
                    <button
                      className="b1-btn min-w-80"
                      onClick={() => this.switchPageView(this)}
                      disabled={this.checkDisabled()}
                    >
                      {this.state.pageType === "KycPage" ? "Next" : "Back"}
                    </button>
                  )}
                </div>
              </div>

              <Footer {...this.props} />
            </Col>
          </Row>
        </div>
        <Modal
          show={this.state.showRejectModal}
          onHide={this.handleReject.bind(this, "")}
          centered
          className="deliva-popup"
        >
          <Modal.Body>
            <div className="modal-content-wrap ">
              <div className="text-center">
                <Image src={RejectIcon} className="img-fluid reject-img " />
                <h4 className="color-red mt-3 fs-22">
                  Are you sure to reject this request ?
                </h4>
                <p className="color-head">
                  Please add/choose the reason of rejection{" "}
                </p>
              </div>

              <Form.Group controlId="exampleForm.ControlSelect1">
                <Form.Label className="color-head">
                  Choose the Reason
                </Form.Label>
                <Form.Control
                  as="select"
                  name="rejectionReason"
                  onChange={this.onChange}
                  value={this.state.rejectionReason}
                  className="py-0"
                >
                  <option value="Other">Other</option>
                  <option value="Invalid Passport Details">
                    Invalid Passport Details
                  </option>
                  <option value="Invalid Banking Details">
                    Invalid Banking Details
                  </option>
                  <option value="Invalid ID Proof">Invalid ID Proof</option>
                  <option value="Criminal Background">
                    Criminal Background
                  </option>
                </Form.Control>
              </Form.Group>
              {this.state.rejectionReason === "Other" && (
                <Form.Group controlId="exampleForm.ControlTextarea1">
                  <Form.Label className="color-head">
                    Rejection details
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows="3"
                    name="kycRejectRemark"
                    onChange={this.onChange}
                    maxLength="100"
                  />
                  <span className="min-char d-block">Max 100 chars</span>

                  {errors.kycRejectRemarkError && (
                    <span className="text-danger">
                      {errors.kycRejectRemarkError}
                    </span>
                  )}
                </Form.Group>
              )}
              <div className="text-left mb-4">
                <div className="mb-2">Action</div>
                <Form.Check
                  type="radio"
                  label="Resubmission"
                  name="radioOptions"
                  id="radio1"
                  title="Enables the user to submit the document again."
                  checked={this.state.selectedOption === "resubmit"}
                  onChange={() => this.handleRadioChange("resubmit")}
                  className="d-inline-block me-2"
                />
                <Form.Check
                  type="radio"
                  label="Block"
                  name="radioOptions"
                  id="radio2"
                  title="Prevents the user from resubmitting the document."
                  checked={this.state.selectedOption === "blocked"}
                  onChange={() => this.handleRadioChange("blocked")}
                  className="d-inline-block mx-2"
                />
              </div>
              <div className="text-center">
                <button
                  className="cancel-btn mr-4 min-w-80"
                  onClick={this.handleReject.bind(this, "")}
                >
                  No
                </button>
                <button
                  className="b1-btn min-w-80"
                  onClick={this.submitReject.bind(this)}
                >
                  Yes
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {this.state.successModal && (
          <CustomKycModal
            show={this.state.successModal}
            onHide={() => this.approvalSuccessModal(this)}
            icon={approved}
            iconClass="img-fluid user-block-img"
            heading="Approved"
            headingClass="lightGreenText mt-3"
            text={`${this.state.daName} #${this.state.userId} details are approved`}
            buttons={[
              {
                label: "Back",
                className: "b1-btn min-w-80",
                onClick: () => this.nextPageModal(this),
              },
            ]}
          />
        )}

        {this.state.showKycApproveModal && (
          <CustomKycModal
            show={this.state.showKycApproveModal}
            onHide={() => this.setState({ showKycApproveModal: false })}
            icon={ApprovedChecked}
            iconClass="img-fluid user-block-img"
            heading="Are you sure to approve this request?"
            headingClass="color-green mt-3 fs-22 nowrap"
            text="Please write the reason for approval"
            buttons={[
              {
                label: "No",
                className: "cancel-btn mr-4 min-w-80",
                onClick: () =>
                  this.setState({ showKycApproveModal: false, errors: {} }),
              },
              {
                label: "Yes",
                className: "b1-btn min-w-80",
                onClick: () =>
                  this.approveDA(profile_detail.userId, profile_detail.name),
                disabled: this.state.showLoader,
              },
            ]}
          >
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Control
                as="textarea"
                rows="3"
                name="kycApproveRemark"
                onChange={this.handleRemarksChange}
                maxLength="100"
              />

              <span className="min-char d-block">Max 100 chars</span>

              {errors.kycRemarkError && (
                <span className="text-danger">{errors.kycRemarkError}</span>
              )}
            </Form.Group>
          </CustomKycModal>
        )}
      </div>
    );
  }
}
export default DeliveryAgentDetails;
